module.exports = __webpack_public_path__ + "static/media/IMG_20210616_093948_526.58edd8d3.jpg";